import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Card, Modal } from 'react-bootstrap'
import EmergencyRoomVisitsGraph from './components/EmergencyRoomVisitsGraph'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import SourceLink from '../../component/chartLinkData'
import EmergencyRoomVisitsFranceGraph from './components/EmergencyRoomVisitsFranceGraph'

interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  const [showSeasonModalFR, setShowSeasonModalFR] = useState(false)
  const [selectedDiagnosisCategories, setSelectedDiagnosisCategories] =
    useState<string>('ALL_RESP_DIAG')
  const [selectedAgeClass, setSelectedAgeClass] = useState<string[]>(['0-200'])
  // Pour la France
  const [selectedDiagnosisCategoriesFR, setSelectedDiagnosisCategoriesFR] =
    useState<string>('IRA')
  const [selectedAgeClassFR, setSelectedAgeClassFR] = useState<string[]>(['0-200'])
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      Emergency room visits for respiratory syndromes {season} (France - Lyon){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The graph shows the number of emergency room visits for respiratory
              infections in Lyon area (weekly counts from Hospices Civils de Lyon).
              Nowcasting estimator of the numbers is preprocessed to account for
              potential reporting delay. The data is grouped by age group and by
              specific type of respiratory infections, such as influenza, RSV,
              SARS-CoV-2, other viral respiratory infections. The alert threshold is
              based on historical data.{' '}
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )
  const HeaderEmergencyRoomFranceChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      Oscour – Emergency room visits for respiratory syndromes (France) {season}{' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              Emergency department visits for influenza/flu-like illness correspond to visits to the emergency department with a medical diagnosis of influenza/flu-like illness established as the primary or secondary diagnosis by emergency physicians (ICD-10 codes: J09-J11.8). Data from the OSCOUR® network are collected using the Emergency Department Visit Summary (EDVS) format. Nearly 700 emergency departments participate in the OSCOUR® network, accounting for 96% of national emergency department visits in 2024.
              The number of emergency department visits for influenza/flu-like illness by age group and geographic area is compared to the total number of emergency department visits for which at least one medical diagnosis is recorded, for the same age group and geographic area.

              The indicators for monitoring emergency department visits (data from the OSCOUR® network) and SOS Médecins consultations for influenza/flu-like illness are derived from the SurSaUD® syndromic surveillance system (Health Surveillance of Emergencies and Deaths) https://www.santepubliquefrance.fr/surveillance-syndromique-sursaud-R.{' '}
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )
  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderChart />
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <EmergencyRoomVisitsGraph
                  season={mainSeason}
                  selectedAgeClass={selectedAgeClass}
                  setSelectedAgeClass={setSelectedAgeClass}
                  selectedDiagnosisCategories={selectedDiagnosisCategories}
                  setSelectedDiagnosisCategories={setSelectedDiagnosisCategories}
                />
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <p className='card-text source row'>
                    {/* <i style={{fontSize: '12px'}}  className='mb-2'>
                      * The baseline represents the smoothed value from the previous year.
                      Confidence intervals are calculated by determining the critical value using
                      the normal distribution corresponding to a 95% confidence level. The standard
                      deviation is multiplied by this critical value to obtain the margins of error,
                      which are then added and subtracted from the sample mean to define the
                      interval bounds. The computed alert corresponds to a binary value of 0/1 for
                      each week, diagnosis, age group, geographical origin or/and RSS duration. It
                      indicates, when equal to 1, that the current case count exceeds the upper
                      bound of the baseline case count.
                    </i> */}
                    <i>
                      Source:{' '}
                      <a className='fw-bold' href='https://www.chu-lyon.fr'>
                        Hospices Civils de Lyon
                      </a>
                    </i>{' '}
                  </p>
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonModal}
        onHide={() => setShowSeasonModal(false)}
        centered
      >
        <Modal.Header closeButton className='py-4'>
          <Modal.Title className='bold'>
            <HeaderChart season={'2023-2024'} />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <EmergencyRoomVisitsGraph
            season={modalSeason}
            selectedAgeClass={selectedAgeClass}
            setSelectedAgeClass={setSelectedAgeClass}
            selectedDiagnosisCategories={selectedDiagnosisCategories}
            setSelectedDiagnosisCategories={setSelectedDiagnosisCategories}
          />
          <div className="d-flex justify-content-between align-items-center mt-2">
            <p className='card-text source row'>
              <i>
                Source:{' '}
                <a className='fw-bold' href='https://www.chu-lyon.fr'>
                  Hospices Civils de Lyon
                </a>
              </i>{' '}
            </p>
          </div>
        </Modal.Body>
      </Modal>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderEmergencyRoomFranceChart />
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <EmergencyRoomVisitsFranceGraph
                  season={mainSeason}
                  selectedAgeClassFR={selectedAgeClassFR}
                  setSelectedAgeClassFR={setSelectedAgeClassFR}
                  selectedDiagnosisCategoriesFR={selectedDiagnosisCategoriesFR}
                  setSelectedDiagnosisCategoriesFR={setSelectedDiagnosisCategoriesFR}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source' style={{ maxWidth: '85%' }}>
                    <i>
                      Source:
                      <a className='fw-bold' href='#'>
                        {' '}
                        The indicators for monitoring emergency room visits (data from the OSCOUR® network) come from the SurSaUD® syndromic surveillance system (Health Surveillance of Emergencies and Deaths).
                      </a>
                    </i>
                  </p>
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonModalFR}
        onHide={() => setShowSeasonModalFR(false)}
        centered
      >
        <Modal.Header closeButton className='py-4'>
          <Modal.Title className='bold'>
            <HeaderEmergencyRoomFranceChart season={'2023-2024'} />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <EmergencyRoomVisitsFranceGraph
            season={modalSeason}
            selectedAgeClassFR={selectedAgeClassFR}
            setSelectedAgeClassFR={setSelectedAgeClassFR}
            selectedDiagnosisCategoriesFR={selectedDiagnosisCategoriesFR}
            setSelectedDiagnosisCategoriesFR={setSelectedDiagnosisCategoriesFR}
          />
          <p className='card-text source'>
            <p className='card-text source mt-2 row'>
              <i style={{ fontSize: '12px' }} className=''>
                * calculated based on historical values ​​(2020-2021 to 2024-2025)
              </i>
            </p>
          </p>
          <div className="d-flex justify-content-between align-items-center">
            <p className='card-text source'>
              <i>
                Source:
                <a className='fw-bold' href='#'>
                  {' '}
                  The indicators for monitoring emergency room visits (data from the OSCOUR® network) for influenza/flu-like syndrome come from the SurSaUD® syndromic surveillance system (Health Surveillance of Emergencies and Deaths).
                </a>
              </i>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

const EmergencyRoomVisits = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPage />
    </>
  )
}

export { EmergencyRoomVisits }
